import {
    humanCalculators_En,
    islamicCalculators_En,
    studyCalculators_En,
    healthCalculators_En,
    financialCalculators_En,
    womenCalculators_En,
    mathCalculators_En,
    physicsCalculators_En,
    otherCalculators_EN,
    chemistryCalculators_En,
  } from "../En/ConstantsEN";
import SharedHelmet from "./Helmet";
import { useState } from "react";
import { Icons } from "../../Components/Icons";

const TITLE = "All Calculators";
const DESCRIPTION =
  "Here you can find all the calculators available in our website.";
const KEYWORDS = "All Calculators";
const OG_URL = "https://do-calculate.com/en/all-calculators/";

const cardData = [
  {
    cardNumber: 8,
    cardTitle: "Chemistry Calculators",
    cardIcon: <Icons.Biotech />,
    cardItems: chemistryCalculators_En,
    calculatorUrl: "/en/chemistry-calculators/",
  },
  {
    cardNumber: 3,
    cardTitle: "Women Calculators",
    cardIcon: <Icons.Female />,
    cardItems: womenCalculators_En,
    calculatorUrl: "/en/women-calculators/",
  },
  {
    cardNumber: 5,
    cardTitle: "Zakat Calculators",
    cardIcon: <Icons.VolunteerActivism />,
    cardItems: islamicCalculators_En,
    calculatorUrl: "/en/zakat-calculators/",
  },
  {
    cardNumber: 9,
    cardTitle: "Financial Calculators",
    cardIcon: <Icons.AttachMoney />,
    cardItems: financialCalculators_En,
    calculatorUrl: "/en/financial-calculators/",
  },
  {
    cardNumber: 1,
    cardTitle: "Time and Date Calculators",
    cardIcon: <Icons.AccessTime />,
    cardItems: humanCalculators_En,
    calculatorUrl: "/en/date-time-calculators/",
  },
  {
    cardNumber: 10,
    cardTitle: "Other Calculators",
    cardIcon: <Icons.MoreHoriz />,
    cardItems: otherCalculators_EN,
    calculatorUrl: "/en/other-calculators/",
  },
  {
    cardNumber: 6,
    cardTitle: "Univerity GPA Calculators",
    cardIcon: <Icons.School />,
    cardItems: studyCalculators_En,
    calculatorUrl: "/en/study-calculators/",
  },
  {
    cardNumber: 7,
    cardTitle: "Physics Calculators",
    cardIcon: <Icons.Science />,
    cardItems: physicsCalculators_En,
    calculatorUrl: "/en/physics-calculators/",
  },
  {
    cardNumber: 2,
    cardTitle: "Health and Fitness Calculators",
    cardIcon: <Icons.Favorite />,
    cardItems: healthCalculators_En,
    calculatorUrl: "/en/health-calculators/",
  },
  {
    cardNumber: 4,
    cardTitle: "Math Calculators",
    cardIcon: <Icons.Calculate />,
    cardItems: mathCalculators_En,
    calculatorUrl: "/en/math-calculators/",
  },
];

function CardGroups() {
  const [searchTerm, setSearchTerm] = useState("");
  const filteredCardData = cardData.filter((card) =>
    card.cardItems.some((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <div style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
       <div
        className="row row-cols-1 row-cols-md-4 g-4"
        style={{ position: "relative", zIndex: "1" }}
      >
        {filteredCardData.map((card, index) => (
          <div className="col" xs key={index} style={{ paddingBottom: "10px" }}>
            <div>
              <h2 style={{ fontSize: "16px" }}>
                {card.cardIcon} {card.cardTitle}
              </h2>
              <ul style={{ padding: 0, listStyleType: "none" }}>
                {card.cardItems.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <a
                      href={item.link}
                      className="item-link"
                      style={{ fontSize: "14px" }}
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
      If you have any inquiries, would like us to add more calculators, or if you encounter any issues with a specific calculator, please contact us at the following email address: info@do-calculate.com
      </div>
    </div>
  );
}

export default CardGroups;